export class Note 
{
    [key: string]: string;
    constructor (public name:string,public description:string, public summary:string,
        public project:string,  public version:string)
        {}
    
}

export default Note